<template>
  <div class="form">
    <el-form ref="form" :model="form" label-position="right" label-width="0px">
      <baseInfoPart
        :item="item"
        :disabled="disabled"
        ref="baseInfoPart"
      ></baseInfoPart>
      <learningExperiencePart
        :item="item"
        :disabled="disabled"
        ref="learningExperiencePart"
      ></learningExperiencePart>
      <currentWorkPart
        :item="item"
        :disabled="disabled"
        ref="currentWorkPart"
      ></currentWorkPart>
      <resumePart
        :item="item"
        :disabled="disabled"
        ref="resumePart"
      ></resumePart>
      <homeMainMemberPart
        :item="item"
        :disabled="disabled"
        ref="homeMainMemberPart"
      ></homeMainMemberPart>

      <div>
        <partHeader title="备注" :required="true"></partHeader>
        <el-row>
          <el-col :span="24">
            <el-input
              type="textarea"
              v-model="form.note"
              rows="5"
              :disabled="disabled"
            ></el-input>
          </el-col>
        </el-row>
      </div>
      <el-row style="margin-top: 20px">
        <el-col :span="2" :offset="22">
          <el-button
            type="primary"
            size="small"
            @click="submit"
            v-show="!disabled"
            >保存</el-button
          >
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<style lang="scss" scoped>
.form {
  background-color: #f2f2f2;
  border-top: 1px solid #e2e2e2;
  padding: 10px;
  //   height: 500px;
  //   overflow-y: auto;
}
</style>
<script>
import baseInfoPart from "./baseInfoPart.vue";
import learningExperiencePart from "./learningExperiencePart.vue";
import currentWorkPart from "./currentWorkPart.vue";
import resumePart from "./resumePart.vue";
import homeMainMemberPart from "./homeMainMemberPart.vue";
import partHeader from "./partHeader.vue";
import request from "@/api/personCenter.js";

export default {
  name: "applicationInfo",
  props: {
    disabled: {
      type: Boolean,
      required: true
    },
    item: {
      type: Object,
      default: () => {}
    },
    //是否是添加
    isTj: {
      type: Boolean
    }
  },
  components: {
    baseInfoPart,
    learningExperiencePart,
    currentWorkPart,
    resumePart,
    homeMainMemberPart,
    partHeader
  },
  data() {
    return {
      form: {
        note: "" //备注
      },
      options: {
        recruitment: [],
        gender: [],
        nation: [],
        politicsFace: [], //政治面貌
        education: [], //学历
        degree: [], //学位
        period: [] //学制
      }
    };
  },
  mounted() {
    if (!this.$route.params.isTj) {
      this.form.note = this.item.bz;
    }
  },
  methods: {
    //提交报名信息
    submit() {
      let baseInfoPart = this.$refs.baseInfoPart.validate();
      let learningExperiencePart = this.$refs.learningExperiencePart.validate();
      let currentWorkPart = this.$refs.currentWorkPart.validate();
      let resumePart = this.$refs.resumePart.validate();
      let homeMainMemberPart = this.$refs.homeMainMemberPart.validate();
      this.showMessage = this.form.note == "";
      //如果各个组件校验返回的数据不是null，则提交报名信息
      if (
        baseInfoPart &&
        learningExperiencePart &&
        currentWorkPart &&
        resumePart &&
        homeMainMemberPart &&
        !this.showMessage
      ) {
        let param = {
          ...baseInfoPart,
          ...learningExperiencePart,
          ...currentWorkPart,
          ...resumePart,
          ...homeMainMemberPart,
          bz: this.form.note,
          yhid: this.$store.state.userInfo.yhid
        };
        console.log(param);
        if (!this.$route.params.isTj) {
          request
            .modifyPost(param)
            .then(() => {
              this.$message({
                message: "修改成功",
                type: "success",
                showClose: true
              });
              // this.reset();
              this.$parent.queryGrjl();
            })
            .catch(err => {
              console.log("error");
              console.log(err);
            });
        } else {
          request
            .applyPost(param)
            .then(res => {
              this.$message({
                message: "保存成功",
                type: "success",
                showClose: true
              });
              this.reset();
              this.$router.push("/personCenter");
              console.log("success");
              console.log(res);
            })
            .catch(err => {
              console.log("error");
              console.log(err);
            });
        }
      }
    },
    reset() {
      this.$refs.baseInfoPart.reset();
      this.$refs.learningExperiencePart.reset();
      this.$refs.currentWorkPart.reset();
      this.$refs.resumePart.reset();
      this.$refs.homeMainMemberPart.reset();
      this.form.note = null;
    }
  }
};
</script>
